export default "__VITE_ASSET__CAmxt9C5__"